import { render } from "./BaixaTitulosModal.vue?vue&type=template&id=70faad6c&scoped=true&ts=true"
import script from "./BaixaTitulosModal.vue?vue&type=script&lang=ts"
export * from "./BaixaTitulosModal.vue?vue&type=script&lang=ts"

import "./BaixaTitulosModal.vue?vue&type=style&index=0&id=70faad6c&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70faad6c"]])

export default __exports__